export default "/_next/static/284042b7bcb092fd4af51815742da9a3.jpg";